module.exports = __webpack_public_path__ + "static/media/icon-11.841ca303.png";